export default function Billboard({ data }) {
  return (
    <div className="ui-card p-4 relative xl:p-6">
      <div className="flex flex-col">
        <div className="grid ui-grid-carousel gap-2">
          <svg
            className={`ui-icon w-12 h-12 ${data.svgClass}`}
            focusable="false"
            aria-hidden="true"
            role="presentation"
          >
            <use href={`#${data.svgUse}`}></use>
          </svg>
          <h2 className="text-2xl font-body font-semibold my-auto">
            {data.title}
          </h2>
        </div>

        <div className="mt-4">{data.description}</div>
      </div>
    </div>
  );
}
